import {Component, Input, OnInit} from '@angular/core';
import {IRiskMatrixEntry} from "../../../message-models/risk-matrix-entry.interface";
import {IRiskInfo} from "../../../message-models/risk-info.interface";
import {IJobLevelInfo} from "../../../message-models/job-level.interface";
import {RiskMatrixLevel} from "../../../message-models/risk-matrix-level.enum";
import {IOperative} from "../../../message-models/operative.interface";
import {OperativeInfo} from "../../../domain-model/operative-info.class";

@Component({
  selector: 'app-risk-matrix',
  templateUrl: './risk-matrix.component.html',
  styleUrls: ['./risk-matrix.component.scss']
})
export class RiskMatrixComponent implements OnInit {
  @Input() riskMatrixEntries: IRiskMatrixEntry[] = [];
  @Input() allRisks: IRiskInfo[] = [];
  @Input() allJobLevels: IJobLevelInfo[] = [];
  @Input() operatives: OperativeInfo[] = [];

  isHV = false;

  constructor() { }

  ngOnInit(): void {
    if (this.operatives?.length === 1) {
      if (this.operatives[0].currentOperativeTypeId === "9e693556-8c16-44a2-b1e4-2c8d18b081ad") {
        this.isHV = true;
      }
    }
    
  }

  getRiskMatrixCell(jobIndex: number, riskIndex: number) : IRiskMatrixEntry{
    const jobLevel = this.getJobLevelWithIndex(jobIndex);
    if (!jobLevel)
      return null;

    const risk = this.getRiskWithIndex(riskIndex);
    if (!risk)
      return null;

    return this.riskMatrixEntries.find(e => e.riskId === risk.id && e.jobLevelId === jobLevel.id);
  }

  getJobLevelWithIndex(jobIndex: number) {
    return this.allJobLevels.find(l => l.index === jobIndex);
  }

  getRiskWithIndex(riskIndex: number) {
    return this.allRisks.find(r => r.index === riskIndex);
  }

  getMatrixClassFor(jobIndex: number, riskIndex: number) {
    const matrixEntry = this.getRiskMatrixCell(jobIndex, riskIndex);
    if (!matrixEntry)
      return '';

    switch (matrixEntry.riskMatrixLevel){
      case RiskMatrixLevel.low:
        return 'low-risk-cell';
      case RiskMatrixLevel.warning:
        return 'warning-risk-cell';
      case RiskMatrixLevel.danger:
        return 'danger-risk-cell';
    }

    return '';
  }

  getOperativeNumbersInCell(jobIndex: number, riskIndex: number): number {
    const matrixEntry = this.getRiskMatrixCell(jobIndex, riskIndex);
    if (!matrixEntry)
      return 0;

    let numOps: number = 0;
    this.operatives.forEach(o => {
      if (o.riskMatrixLevel === matrixEntry.riskMatrixLevel &&
          o.currentRiskId === matrixEntry.riskId &&
          o.currentJobLevelId == matrixEntry.jobLevelId){
        numOps++;
      }
    })

    return numOps;
  }

  getIconNameInCell(jobIndex: number, riskIndex: number): any {
    if (this.operatives?.length > 1)
      return "";

    const numOpsInCell = this.getOperativeNumbersInCell(jobIndex, riskIndex);
    if (numOpsInCell === 0)
      return "";

    const matrixEntry = this.getRiskMatrixCell(jobIndex, riskIndex);
    switch (matrixEntry.riskMatrixLevel) {
      case RiskMatrixLevel.low:
        return 'check-circle';
      case RiskMatrixLevel.warning:
        return 'exclamation-triangle';
      case RiskMatrixLevel.danger:
        return 'siren-on';
    }
    return "";
  }
}
